var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetDtm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.713,
    height: 314.3,
    viewBox: "0 0 143.713 314.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.048,325.885c0-30.157.019-58.574.019-101.018,0-19.593-1.591-33.311-4.314-40.3A3.135,3.135,0,0,1,4.7,180.16c23.617,0,110.272,0,134.1.009a3.342,3.342,0,0,1,3.125,4.547c-2.723,7.064-4.388,20.529-4.388,39.879V325.885",
    transform: "translate(0 -11.585)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 141.795,
    transform: "translate(1.547 172.505)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 142.562,
    transform: "translate(142.126 171.737)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.99,330.9V279.289A21.119,21.119,0,0,1,71.109,258.17h0a21.119,21.119,0,0,1,21.119,21.119V330.9",
    transform: "translate(-3.118 -16.602)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.763,
    cy: 12.763,
    r: 12.763,
    transform: "translate(55.667 248.604)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.927,
    cy: 17.6,
    rx: 24.927,
    ry: 17.6,
    transform: "translate(12.7 168.5)",
    fill: "#233e93",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.927,
    cy: 17.6,
    rx: 24.927,
    ry: 17.6,
    transform: "translate(80.875 168.93)",
    fill: "#fcdb00",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.924 149.851)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.703,
    cy: 9.348,
    rx: 17.703,
    ry: 9.348,
    transform: "translate(0 24.665)",
    fill: "#172447",
    stroke: "#162448",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.703,
    cy: 9.348,
    rx: 17.703,
    ry: 9.348,
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,173.951v19.631H21.19V173.436c16.7,15.289,35.416,5.717,35.416.524Z",
    transform: "translate(-21.19 -160.795)",
    fill: "#162448",
    stroke: "#142447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24.749,
    transform: "translate(17.703 9.348)",
    fill: "none",
    stroke: "#142447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24.749,
    transform: "translate(9.918 13.156)",
    fill: "none",
    stroke: "#142447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24.749,
    transform: "translate(25.788 13.287)",
    fill: "none",
    stroke: "#142447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.888,174.261v-30.2H57.539l-18.7-23.907-18.7,23.907H33.089v30.27a31.346,31.346,0,0,0,11.808-.056Z",
    transform: "translate(-1.198 -7.726)",
    fill: "#ec1c24",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.79,84.28V104.8c0,1.871,6.419,4.894,14.335,4.894S53.46,106.727,53.46,104.8V84.28",
    transform: "translate(-1.498 -5.42)",
    fill: "none",
    stroke: "#162448",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.423,26.711l.318,20.641-7.42,4.856a1.584,1.584,0,0,0-.711,1.319V91.4c8.4,6.372,29.306,6.129,36.492,0-.075-29.858,0-37.933,0-37.933a1.591,1.591,0,0,0-.627-1.263l-6.138-4.585V26.692a1.569,1.569,0,0,0-1.572-1.572H30A1.568,1.568,0,0,0,28.423,26.711Z",
    transform: "translate(-1.229 -1.615)",
    fill: "#172447",
    stroke: "#162448",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 48.591,
    transform: "translate(28.486)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 48.6,
    transform: "translate(47.789)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 138.427,
    transform: "translate(96.66)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 138.436,
    transform: "translate(115.954)",
    fill: "none",
    stroke: "#172447",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.787,
    cy: 1.787,
    r: 1.787,
    transform: "translate(35.84 85.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.243,62.668V58.074a35.872,35.872,0,0,1-14.494,3.153A35.69,35.69,0,0,1,23.88,57.84v4.622a37.793,37.793,0,0,0,15.869,3.2,37.182,37.182,0,0,0,14.494-2.985Z",
    transform: "translate(-1.439 -3.719)",
    fill: "#233e93"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.538 150.881)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.264,
    cy: 9.348,
    rx: 17.264,
    ry: 9.348,
    transform: "translate(0 24.665)",
    fill: "#172447",
    stroke: "#162448",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.264,
    cy: 9.348,
    rx: 17.264,
    ry: 9.348,
    fill: "#172447",
    stroke: "#162448",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24.665,
    transform: "translate(0 9.348)",
    fill: "none",
    stroke: "#162448",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24.665,
    transform: "translate(34.518 9.348)",
    fill: "none",
    stroke: "#162448",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.3,
    height: 23.598,
    transform: "translate(0.87 10.414)",
    fill: "#172447",
    stroke: "#162448",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.273,102.631l.318,21.577-7.42,3.949a1.24,1.24,0,0,0-.711,1.067v38.036c8.4,5.184,29.306,4.987,36.492,0-.075-24.291,0-38.092,0-38.092a1.207,1.207,0,0,0-.627-1.02l-6.138-3.733v-21.8a1.452,1.452,0,0,0-1.572-1.282h-18.77a1.436,1.436,0,0,0-1.572,1.3Z",
    transform: "translate(-5.913 -6.516)",
    fill: "#172447",
    stroke: "#142447",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.833,139.248v-4.594a36.861,36.861,0,0,1-30.363-.234v4.622a37.794,37.794,0,0,0,15.869,3.2,37.182,37.182,0,0,0,14.494-2.985Z",
    transform: "translate(-6.107 -8.644)",
    fill: "#fcdb00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.787,
    cy: 1.787,
    r: 1.787,
    transform: "translate(104.015 152.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.787,
    cy: 1.787,
    r: 1.787,
    transform: "translate(104.015 158.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.787,
    cy: 1.787,
    r: 1.787,
    transform: "translate(35.84 207.219)",
    fill: "#172447"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.787,
    cy: 1.787,
    r: 1.787,
    transform: "translate(103.762 207.219)",
    fill: "#172447"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.787,
    cy: 1.787,
    r: 1.787,
    transform: "translate(103.762 212.926)",
    fill: "#172447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.431,176.866c-8.384,0-15.729-2.4-18.471-5.642V173.8c3.724,2.985,10.527,4.94,18.471,4.94s15.373-2.143,18.967-5.362V170.55c-2.236,3.584-10,6.325-18.967,6.325Z",
    transform: "translate(-5.881 -10.967)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetDtm);
export default __webpack_public_path__ + "static/media/resetDTM.a2e4858b5213124d79c58e44e4fcfeca.svg";
export { ForwardRef as ReactComponent };